import { Box, List, ListItemButton, ListItemText } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import {
  REGION_OPTIONS,
  REGION_FLAGS,
  type Languages,
} from '../../../../../i18n/i18n.language-config';
import { selectUserLanguagePreferences } from '../../../../../store/selectors/ui-settings.selectors';
import { setPlatformLanguage } from '../../../../../store/actions';
import DatePicker, {
  usePopOverState,
} from '../../../../agencies/quotes/PrimeX/customizeQuote/components/DatePicker';

const LanguageSelector = () => {
  // TODO: Remove this reference
  const platformLanguage = useSelector(selectUserLanguagePreferences);
  const popOverState = usePopOverState();
  const dispatch = useDispatch();

  const selectedLanguage = REGION_FLAGS[platformLanguage];

  const handleLanguageSelection = (language: Languages) => {
    popOverState.onClose();
    dispatch(setPlatformLanguage(language));
  };

  return (
    <>
      <Box
        component="button"
        sx={{
          textTransform: 'capitalize',
          fontSize: '2.5rem',
          // The flag is a large emoji; at normal line height its box stood
          // taller than anything else in the header and set the header's height.
          lineHeight: 1,
          // Flag and chevron on one centre line; inline, the chevron sat on
          // the flag's text baseline.
          display: 'inline-flex',
          alignItems: 'center',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
        }}
        onClick={popOverState.onOpen}
      >
        {selectedLanguage}
        <ExpandMoreIcon sx={{ pointerEvents: 'none' }} />
      </Box>
      <DatePicker.PopOver {...popOverState}>
        <List dense>
          {REGION_OPTIONS.map((region) => (
            <ListItemButton
              onClick={() => handleLanguageSelection(region.value)}
            >
              <ListItemText
                style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                primary={
                  <>
                    <span style={{ fontSize: '1.75rem' }}>{region.flag}</span>
                    {region.label}
                  </>
                }
                disableTypography
              />
            </ListItemButton>
          ))}
        </List>
      </DatePicker.PopOver>
    </>
  );
};

export default LanguageSelector;
